import { render, staticRenderFns } from "./hzbProject.vue?vue&type=template&id=595bd9fc&scoped=true&"
import script from "./hzbProject.vue?vue&type=script&lang=js&"
export * from "./hzbProject.vue?vue&type=script&lang=js&"
import style0 from "./hzbProject.vue?vue&type=style&index=0&id=595bd9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595bd9fc",
  null
  
)

export default component.exports